// VehicleQuoteForm.js
import React from 'react';
import LocationAutocomplete from "../LocationAutocomplete/LocationAutocomplete";
import VehicleSelection from "./VehicleSelection";
import {Box, Stack} from "@mui/material";
import VehicleVIN from "./VehicleVIN";
import AdditionalServiceAndPreferences from "./AdditionalServiceAndPreferences";
import { useQuote } from "../../lib/contexts/QuoteContext";
import TypeOfTransport from "./TypeOfTransport";

const VehicleQuoteForm = () => {
   const {
      pickupLocation, setPickupLocation,
      dropoffLocation, setDropoffLocation,
      transportType, setTransportType
   } = useQuote();
   
   return (
      <Stack direction="column" spacing={2}>
         <LocationAutocomplete
            label="Pick‑up Location"
            value={pickupLocation}
            onPlaceSelected={setPickupLocation}
         />
         <LocationAutocomplete
            label="Drop‑off Location"
            value={dropoffLocation}
            onPlaceSelected={setDropoffLocation}
         />
         
         {/* 2‑column row for VIN + TransportType */}
         <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
         >
            <Box sx={{ flex: 1, minWidth: 0 }}>
               <VehicleVIN mode="auto" />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
               <TypeOfTransport />
            </Box>
         </Stack>
         
         {/*<VehicleSelection />*/}
         
         {/*
      // todo - restore later
      <AdditionalServiceAndPreferences mode="auto" />
      */}
      </Stack>
   );
};

export default VehicleQuoteForm;
